<template>
  <b-container>
    <service-form :nuevoServicio="true" :servicioOriginal="servicio" @servicioSubmit="addService"></service-form>
  </b-container>
</template>
<script>
import { mapActions } from "vuex";
import ServiceForm from "@/components/services/ServiceFormV2";
export default {
  name: "service-create",
  mounted() {},
  components: {
    ServiceForm
  },
  data() {
    return {
      servicio: {
        GUID: 0,
        Estado: "",
        Observaciones: "",
        Codigo: Date.now(),
        RecogerCliente: true,
        SolicitudCliente: false,
        CodigoCliente: "",
        OrdenServicio: "",
        CodigoTipoServicio: 0,
        NombreCliente: "",
        Fecha: this.obtenerFecha(),
        Referencia: "",
        FechaPrevista: "",
        EntregaSabado: false,
        Hora: this.obtenerHora(),
        AcuseRecibo: false,
        Retorno: false,
        Gestion: "",
        ImporteValor: 0,
        ImporteReembolso: 0,
        ImporteCobroACuenta: 0,
        ImporteDebido: false,
        PesoTotal: 0,
        NumBultos: 0,
        ReferenciaVia: "",
        Remitente: {
          AvisoEmailDestino: false,
          AvisoEmailRemitente: false,
          AvisoSmsDestino: false,
          AvisoSmsRemitente: false,
          Codigo: "",
          CodigoCliente: "",
          CodigoPostal: "",
          Corporativo: "",
          DepartamentoCliente: "",
          Direccion: "",
          Email: "",
          Id: "",
          IdCliente: "",
          IdDomicilio: "",
          IdPais: "",
          IdPoblacion: "",
          Latitud: 0,
          Longitud: 0,
          Marca: "",
          MasDatos: "",
          Movil: 0,
          Nombre: "",
          Nombre2: "",
          NumeroDireccion: 0,
          Observacion: "",
          PisoDireccion: "",
          Poblacion: 0,
          Pointer: "",
          Referencia: "",
          Telefono: "",
          TipoDireccion: "c/",
          Pais: "España",
          Nif: 0
        },
        Destinatario: {
          AvisoEmailDestino: false,
          AvisoEmailRemitente: false,
          AvisoSmsDestino: false,
          AvisoSmsRemitente: false,
          Codigo: "",
          CodigoCliente: "",
          CodigoPostal: "",
          Corporativo: "",
          DepartamentoCliente: "",
          Direccion: "",
          Email: "",
          Id: "",
          IdCliente: "",
          IdDomicilio: "",
          IdPais: "",
          IdPoblacion: "",
          Latitud: 0,
          Longitud: 0,
          Marca: "",
          MasDatos: "",
          Movil: 0,
          Nombre: "",
          Nombre2: "",
          NumeroDireccion: 0,
          Observacion: "",
          PisoDireccion: "",
          Poblacion: 0,
          Pointer: "",
          Referencia: "",
          Telefono: "",
          TipoDireccion: "c/",
          Pais: "ESPAÑA",
          Nif: 0
        },
        Bultos: [],
        TipoServicio: {
          Codigo: null,
          Nombre: ""
        }
      }
    };
  },
  methods: {
    ...mapActions({
      createService: "services/addService"
    }),
    async addService(data) {
      let ok = await this.createService(data.servicio);
      if (ok.estado) {
        if (data.imprimir) {
          let numeroExpedicion = ok.respuesta.GrabarExpedicionSolicitudOSXML.EXPEDICION.REFERENCIAENTREGA;
          let numeroOrden = ok.respuesta.GrabarExpedicionSolicitudOSXML.EXPEDICION.NUMERO;
          await this.imprmir(numeroExpedicion, numeroOrden);
        }
        this.$router.push("/servicios");
      }
    },
    obtenerFecha() {
      const toTwoDigits = num => (num < 10 ? "0" + num : num);
      let today = new Date();
      let year = today.getFullYear();
      let month = toTwoDigits(today.getMonth() + 1);
      let day = toTwoDigits(today.getDate());
      return `${year}-${month}-${day}`;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    obtenerHora() {
      const toTwoDigits = num => (num < 10 ? "0" + num : num);
      let today = new Date();
      let hora = toTwoDigits(today.getHours());
      let minuto = toTwoDigits(today.getMinutes());
      return `${hora}:${minuto}`;
    },
    async imprmir(numeroExpedicion, numeroOrden) {
      this.$store.commit("setLoading", true, { root: true });
      let ruta = this.$apiRoute + "expediciones/etiqueta?numeroExpedicion=" + numeroExpedicion + "&numeroOrden=" + numeroOrden;

      let res = await fetch(
        ruta,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("_token")
          }
        }
      );

      if (!res.ok) {
        this.$store.commit("setLoading", false, { root: true });
        this.$toast("No se pudo imprimir", { color: "blue" });
        return;
      }

      let b64 = await res.json();
      b64 = "data:application/pdf;base64," + b64.ImprimirEtiqueta;
      res = await fetch(b64);
      let response = await res.blob();
      let blob = new Blob([response], { type: "application/pdf" });
      var fileUrl = URL.createObjectURL(blob);
      var wnd = window.open(fileUrl, "_blank");
      this.$store.commit("setLoading", false, { root: true });

      await this.sleep(500);
      try { wnd.print(); } catch (error) { }

      /*let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Etiqueta-" + numeroExpedicion + ".pdf";*/
      //link.click();
    }
  }
};
</script>
